<template>
	<aside>
		
		<HeaderContent title="List Personel" btnText="Personel Baru" :isModal="false" target="/driver/add"/>

		<hr class="mt-4 mt-m-1">

		<Alert :status="$route.params.status"/>

		<SearchFilter placeholder="Cari nama personel" :limit="limit"/>

		<hr class="mt-4 mt-m-1 hide-on-web">

		<!-- NavBar Table -->
		<nav class="mb-3" v-if="dataTable.status">
			<div class="nav nav-tabs" id="nav-tab" role="tablist">
				<ButtonTab id="nav-all" 			title="Semua" 			:count="dataTable.status.all"   :isActive="true"  onclick="setStatus(), getData()"/>
				<ButtonTab id="nav-waiting-job" 	title="Menunggu Tugas" 	:count="dataTable.status.waiting" :isActive="false" onclick="setStatus(1), getData()"/>
				<ButtonTab id="nav-onjob" 			title="Sedang Bertugas" :count="dataTable.status.on_duty" :isActive="false" onclick="setStatus(2), getData()"/>
				<ButtonTab id="nav-notactive" 		title="Tidak Aktif" 	:count="dataTable.status.inactive" :isActive="false" onclick="setStatus(3), getData()"/>
			</div>
		</nav>

		<!-- Table -->
		<section v-if="isloading" class="text-center">
			<img src="img/loading.gif" alt="Bisa Cek" class="mx-auto" style="width: 3%">
		</section>
		<section v-else>
		<div class="tab-content" id="nav-tabContent">
			<div class="tab-pane fade show active" id="nav-all" role="tabpanel">
				<NoList v-if="dataTable.total == 0" :title="params.length > 0 ?'Pencarian tidak ditemukan' : 'Belum ada driver yang dibuat'" btnText="Driver Baru">
					<template v-slot:buttonAdd>
						<router-link tag="button" to="/driver/add" class="btn btn-custom mx-auto d-block">
							<span><i class="fas fa-plus-circle"></i></span> Personel Baru
						</router-link>
					</template>
				</NoList>

				<List v-if="dataTable.total > 0"
					:dataTable="dataTable.rows"
					urlDelete="/driver"
					page="driver"
					:columns="columns"
					action="action-edit-delete-detail"
					targetModal="nav-all-status"
					:head="thead">
					<template v-slot:columnHeader>
						<thead>
		                    <tr>								
								<th scope="col" v-for="(th, i) in thead" :key="i">{{th}}</th>
							</tr>
		                </thead>
					</template>
				</List>
			</div>
			<div class="tab-pane fade" id="nav-waiting-job" role="tabpanel">
				<NoList v-if="dataTable.total == 0" :title="params.length > 0 ?'Pencarian tidak ditemukan' : 'Belum ada personel yang menunggu tugas'" btnText="Personel Baru">
				</NoList>

				<List v-if="dataTable.total > 0"
					:dataTable="dataTable.rows"
					urlDelete="/driver"
					page="driver"
					:columns="columns"
					action="action-edit-delete-detail"
					targetModal="nav-all-status"
					:head="thead">
					<template v-slot:columnHeader>
						<thead>
		                    <tr>
								<th scope="col" v-for="(th, i) in thead" :key="i">{{th}}</th>
							</tr>
		                </thead>
					</template>
				</List>
			</div>
			<div class="tab-pane fade" id="nav-onjob" role="tabpanel">
				<NoList v-if="dataTable.total == 0" :title="params.length > 0 ?'Pencarian tidak ditemukan' : 'Belum ada driver yang sedang bertugas'" btnText="Personel Baru">
				</NoList>

				<List v-if="dataTable.total > 0"
					:dataTable="dataTable.rows"
					urlDelete="/driver"
					page="driver"
					:columns="columns"
					action="action-edit-delete-detail"
					targetModal="nav-all-status"
					:head="thead">
					<template v-slot:columnHeader>
						<thead>
		                    <tr>
								<th scope="col" v-for="(th, i) in thead" :key="i">{{th}}</th>
							</tr>
		                </thead>
					</template>
				</List>
			</div>
			<div class="tab-pane fade" id="nav-notactive" role="tabpanel">
				<NoList v-if="dataTable.total == 0" :title="params.length > 0 ?'Pencarian tidak ditemukan' : 'Belum ada personel yang tidak aktif'" btnText="Personel Baru">
				</NoList>

				<List v-if="dataTable.total > 0"
					:dataTable="dataTable.rows"
					urlDelete="/driver"
					page="driver"
					:columns="columns"
					action="action-edit-delete-detail"
					targetModal="nav-all-status"
					:head="thead">
					<template v-slot:columnHeader>
						<thead>
		                    <tr>
								<th scope="col" v-for="(th, i) in thead" :key="i">{{th}}</th>
							</tr>
		                </thead>
					</template>
				</List>
			</div>
		</div>
		</section>

		<img src="img/group-311.png" alt="Bisa Cek" class="mt-5 hide-on-mobile" style="width: 10%">

		<ModalDetail :detail="detail"/>
	</aside>
</template>

<script>
import HeaderContent from '@/components/HeaderContent'
import Alert from '@/components/Alert'
import SearchFilter from '@/components/table/SearchFilter'
import ButtonTab from '@/components/table/ButtonTab'
import NoList from '@/components/table/NoList'
import List from '@/components/table/List'
import ModalDetail from './components/ModalDetail'
import { EventBus } from '@/plugins/bus.js'

export default {
	name: 'DriverIndex',
	components: {
		HeaderContent,
		Alert,
		SearchFilter,
		NoList,
		List,
		ButtonTab,
		ModalDetail
	},
	data() {
		return {
			limit: 5,
			page: 1,
			params: '',
			dataTable: {},
			columns: ['name', 'phone_number', 'sim', 'col_device', 'col_status'],
			thead: ['No', 'Nama Personel', 'Nomor Handphone', 'Nomor SIM', 'Device', 'Status', 'Lainnya'],
			detail: null,
			isloading: true,
			status			: '',
			routeName		: 'DriverIndex'
		}
	},
	beforeMount() {
		let _ = this
		_.getData()
	},
	beforeDestroy(){
		EventBus.$off('changePage' + this.routeName)
		EventBus.$off('deleteEvent' + this.routeName)
		EventBus.$off('changeLimit' + this.routeName)
		EventBus.$off('modalDetail' + this.routeName)
		EventBus.$off('searchFilter' + this.routeName)
    },
	mounted() {
		let _ = this
		window.getData = this.getData;
		window.setStatus = this.setStatus;

		EventBus.$on('deleteEvent' + this.$route.name, resp => {
			_.page = 1
			if ( resp ) {
				_.$route.params.status = ''
				_.$route.params.status = 'update'
				_.getData()
			}
		})

		EventBus.$on('changePage' + this.$route.name, page => {
			_.page = page
			_.getData()
		})

		EventBus.$on('changeLimit' + this.$route.name, limit => {
			_.page = 1
			_.limit = limit
			_.getData()
		})

		EventBus.$on('modalDetail' + this.$route.name, data => {
			_.page = 1
			_.detail = data
		})

		EventBus.$on('searchFilter' + this.$route.name, query => {
			_.page = 1
			_.params = query
			_.getData()
		})
	},
	computed: {
		urlTo() {
			let _ = this
			return 'driver?limit=' + _.limit + '&key=' + _.params + '&page=' + _.page
		}
	},
	methods: {
		getData() {
			let _ = this
			_.isloading = true
			_.axios.get(_.urlTo + ( _.status != '' ? '&status=' + _.status : '' ))
				.then(resp => {
					_.dataTable = resp.data.data
					_.isloading = false
				})
				.catch(err => {
					console.log(err.response)
					_.isloading = false
				})
		},
		setStatus(status){
			this.page = 1
			this.status = status ? status : ''
		}
	}
}
</script>